import angular from 'angular';
import indeterminateProgress from '../indeterminate-progress';
import utils from '../utils';
import treeViewDirective from './tree-view-directive';
import treeViewParentSelector from './tree-view-parent-selector-directive';

module.exports = angular.module('akamai.components.tree-view', [
  indeterminateProgress.name,
  utils.name
])
  .directive('akamTreeView', treeViewDirective)
  .directive('akamTreeViewParentSelector', treeViewParentSelector);
